import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ContentListing from "@/pages/ContentListing";
const ContentListingRoute = () => <ContentListing contentType="white_papers" pageTitle="下载" pageDescription="关于监管策略、质量管理和合规性的深入技术文件、指南和准备度评估。" />;

export const Route = createFileRoute("/zh-cn/downloads/")({
  head: () => buildRouteHead("/zh-cn/downloads"),
  component: ContentListingRoute,
});

